import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth.service';
import { CommonService } from 'src/app/services/common.service';
import { EnvironmentService } from 'src/app/core/services/environment.service';

@Component({
  selector: 'app-complaint-topic',
  templateUrl: './complaint-topic.component.html',
  styleUrls: ['./complaint-topic.component.scss']
})
export class ComplaintTopicComponent implements OnInit {
  @Input() clientType: string;
  @Input() isClient: boolean = false;
  osinergminTemplateUrl: string = `${this.environmentService.virtualOfficeServiceUrl}Complaint/OsinergminTemplate`;
  clientlist = [
    { title: 'Negativa a la instalación del suministro', description: 'Cuando el cliente no se encuentra de acuerdo con la respuesta relacionada a su Solicitud de Factibilidad del Suministro de gas natural.' },
    { title: 'Excesivo consumo', description: 'Cuando el cliente no se encuentra de acuerdo con el consumo de gas natural.' },
    { title: 'Excesiva facturación', description: 'Cliente no se encuentra de acuerdo con el importe facturado en su recibo de distribución de gas natural.' },
    { title: 'Cobro indebido', description: 'Cuando se realiza el cobro del recibo de distribución de gas natural que actualmente se encuentre cancelado o en reclamo.' },
    { title: 'Corte del servicio', description: 'Cuando se ha realizado el corte del suministro de gas natural sin haberlo requerido, o en caso cuente con una deuda pendiente de pago.' },
    { title: 'Reembolso de aportes o contribuciones', description: 'En caso se solicite la devolución de algún pago indebido o en exceso.' },
    { title: 'Reubicación de instalaciones que se encuentren bajo responsabilidad de la concesionaria', description: 'Cuando no se encuentre de acuerdo por la reubicación de alguna instalación a cargo de la Concesionaria.' },
    { title: 'Mala calidad (tensión, interrupciones)', description: 'Cuando no se encuentra conforme con el servicio del suministro de gas natural otorgada por la Concesionaria.' },
    { title: 'Deudas de Terceros', description: 'Cuando se esté realizando el cobro de la deuda de un tercero.' },
    { title: 'Otras cuestiones vinculadas a la prestación de los servicios públicos de electricidad y gas natural.', description: 'Cuando el reclamo no se encuentre detallado dentro de los conceptos antes mencionados, pero se encuentre vinculado al suministro de gas natural.' }
  ];

  noClientList = [
    //{ title: 'Problemas con ubicación de medidor', description: 'Refiere a cuando un vecino o tercero ha colocado su medidor en la propiedad del reclamante.' },
    { title: 'Obras externas', description: 'Refiere a cuando los trabajos constructivos para la habilitación del servicio de gas a vecinos o terceros de la zona vienen afectando al reclamante.' },
    { title: 'Obtención de suministro', description: 'Refiere a cuando el reclamante no está de acuerdo con el proceso de respuesta a su solicitud de factibilidad de suministro de gas.' }
  ]

  clientText = "<p>Estimado (a) Señor (a): <br><br> Usted ha seleccionado la vía del portal web para la presentación de su reclamo.<br> En ese sentido, se le recuerda que la presente vía solamente podrá ser utilizada para la presentación de los reclamos" +
    " regulados por el <a href=" + this.osinergminTemplateUrl + " target='_blank'> Procedimiento Administrativo de Reclamos de los Usuarios de los Servicios Públicos de Electricidad" +
    " y Gas Natural, aprobado por el OSINERGMIN.</a><br><br> En tal sentido, las materias reclamables por esta vía son las siguientes: </p>";
  noClientText = "<p>Estimado (a) Señor (a): <br><br> Esta seleccionando una opción para presentar reclamos para <strong>No Clientes</strong>," +
    "en tal sentido, las materias reclamables por esta vía son las siguientes: </p>";
  list = [];
  text = "";
  constructor(private authService: AuthService,
    private commonService: CommonService,
    private environmentService: EnvironmentService) { }

  ngOnInit() {
    if (this.authService.getAuthToken() && !this.authService.checkIfItIsInsideIframe()) {
      this.list = this.clientlist;
      this.text = this.clientText;
    }
    
    else {
      this.list = this.noClientList;
      this.text = this.noClientText;
    }
  }

}
